//:: start :: review slider scripts :: ==================
$('.review__slider').slick({
  centerMode: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots:true,
  arrows:true,
  prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><path d="M25 30.4316L15 20.4316L25 10.4316" stroke="black" stroke-width="2.5"/></path></svg></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><path d="M15 30.4316L25 20.4316L15 10.4316" stroke="black" stroke-width="2.5"/></path></svg></button>',
  responsive: [
  {
    breakpoint: 767,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 575,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false,
      centerMode: true,
      infinite: true,
    }
  }
]
});
//:: end :: review slider scripts :: ==================

//:: START :: Collapsible panels  :: ==================
document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector(".home_faq_item-header")!=null){
    const firstAccordionItemHeader = document.querySelector(
      ".home_faq_item-header"
    );
    const firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;

    // Open the first accordion item by default
    /* firstAccordionItemHeader.classList.add("active");
    firstAccordionItemBody.style.maxHeight =
      firstAccordionItemBody.scrollHeight + "px";  */

    const accordionItemHeaders = document.querySelectorAll(
      ".home_faq_item-header"
    );

    accordionItemHeaders.forEach((accordionItemHeader) => {
      accordionItemHeader.addEventListener("click", (event) => {
        const currentlyActiveAccordionItemHeader = document.querySelector(
          ".home_faq_item-header.active"
        );
        if (
          currentlyActiveAccordionItemHeader &&
          currentlyActiveAccordionItemHeader !== accordionItemHeader
        ) {
          currentlyActiveAccordionItemHeader.classList.toggle("active");
          currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }
        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
          accordionItemBody.style.maxHeight =
            accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemBody.style.maxHeight = 0;
        }
      });
    });
  }
});

/* on click button panel hide */
document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.faq-buttons .button');
    const panels = document.querySelectorAll('.faqwrapper-grid');

    // Function to show the panel associated with a button
    function showPanel(label) {
        panels.forEach(panel => panel.style.display = 'none'); // Hide all panels
        const targetPanel = document.querySelector(`.faqwrapper-grid[data-panels-label="${label}"]`);
        if (targetPanel) {
            targetPanel.style.display = 'flex'; // Show the target panel
        }
    }

    // Set up event listeners for buttons
    buttons.forEach(button => {
        button.addEventListener('click', function() {
            const targetLabel = this.id;

            // Remove 'active' class from all buttons
            buttons.forEach(btn => btn.classList.remove('active'));

            // Add 'active' class to the clicked button
            this.classList.add('active');

            // Show the panel corresponding to the clicked button
            showPanel(targetLabel);
        });
    });

    // Set default active button and panel on page load
    const defaultButton = document.querySelector('.faq-buttons .button.active');
    if (defaultButton) {
        showPanel(defaultButton.id);
    }
});
//:: END :: Collapsible panels :: ==================

//:: START :: image marquee scripts :: ==================
$('.image_marquee_slider').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  arrows:false,
  dots:false,
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
//:: END :: image marquee scripts :: ==================



//:: START :: Cart progress  :: ==================
var goalAmount = jQuery('.cc-cart-progress').attr('data-goal-amount');
var goalBeforeText = jQuery('.cc-cart-progress').attr('data-before-amount-text');
var goalAfterText = jQuery('.cc-cart-progress').attr('data-after-amount-text');
var goalReachText = jQuery('.cc-cart-progress').attr('data-goal-reached-text');
var formatCurrency = window.theme.moneyFormat;
setInterval(function(){
 if(jQuery('.cart--drawer.drawer--is-open').length>0){
   jQuery.getJSON('/cart.js', function(cart) {
      let cartData = cart.items;
      let cartstr = '';
      let subTotal = 0;
      var cartCounter=0;
      let totalCart = cartData.length;
      console.log("totalCart",totalCart);
      if(cartData.length>0){
        subTotal = cart.original_total_price;
        var percentage_reached = (eval(subTotal) / eval(goalAmount));
        if(parseFloat(percentage_reached) > 100){
          var percentage_reached = 100;
        }
        jQuery('.cc-cart-progress-fill').css("width", Math.round(percentage_reached)+"%");
        jQuery('.cc-cart-progress-fill span').html(Math.round(percentage_reached)+"%");

        jQuery('.cc-cart-progressbar').removeClass("progress-filled");
        jQuery('.cart_shipping_box').hide();
        if(percentage_reached == 100){
          jQuery('.cart_shipping_box').show();
          jQuery('.cc-cart-progressbar').addClass("progress-filled");
        }else{
          jQuery('.cart_shipping_box').hide();
        }


        var cartTotalFull = eval(subTotal) / 100;
        var tempStr = '';
        var svg='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M5.24016 16.4266C4.63349 16.4266 4.11932 16.2149 3.69766 15.7916C3.27543 15.3677 3.06432 14.853 3.06432 14.2474H1.91016V6.0099C1.91016 5.62656 2.03877 5.30656 2.29599 5.0499C2.55266 4.79267 2.87293 4.66406 3.25682 4.66406H14.2818V7.67656H16.2052L19.0902 11.5549V14.2474H17.7435C17.7435 14.853 17.5313 15.3677 17.1068 15.7916C16.6824 16.2149 16.1668 16.4266 15.5602 16.4266C14.954 16.4266 14.4402 16.2149 14.0185 15.7916C13.5963 15.3677 13.3852 14.853 13.3852 14.2474H7.42349C7.42349 14.8563 7.21127 15.3718 6.78682 15.7941C6.36182 16.2163 5.84627 16.4266 5.24016 16.4266ZM5.24349 15.5941C5.61849 15.5941 5.93682 15.4635 6.19849 15.2024C6.4596 14.9407 6.59016 14.6224 6.59016 14.2474C6.59016 13.8724 6.4596 13.5543 6.19849 13.2932C5.93738 13.0321 5.61905 12.9016 5.24349 12.9016C4.86793 12.9016 4.54988 13.0321 4.28932 13.2932C4.02821 13.5543 3.89766 13.8724 3.89766 14.2474C3.89766 14.6224 4.02821 14.9405 4.28932 15.2016C4.55043 15.4627 4.86849 15.5941 5.24349 15.5941ZM15.5643 15.5932C15.9393 15.5932 16.2574 15.4627 16.5185 15.2016C16.7796 14.9405 16.9102 14.6224 16.9102 14.2474C16.9102 13.8724 16.7796 13.5543 16.5185 13.2932C16.2574 13.0321 15.9393 12.9016 15.5643 12.9016C15.1893 12.9016 14.8713 13.0321 14.6102 13.2932C14.349 13.5543 14.2185 13.8724 14.2185 14.2474C14.2185 14.6224 14.349 14.9405 14.6102 15.2016C14.8713 15.4627 15.1893 15.5932 15.5643 15.5932ZM14.2818 11.7474H18.2085L15.7568 8.5099H14.2818V11.7474Z" fill="#190B41"/></path></svg>';
        if(goalAmount > cartTotalFull){
          var goalPendingAmount = (eval(goalAmount) * 100) - subTotal;
          tempStr += goalBeforeText;
          tempStr += '<span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
          tempStr += customMoney(goalPendingAmount, );
          tempStr += '</span>'
          tempStr += goalAfterText;
        }
        else{
          tempStr += goalReachText;
          svg = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M8.28479 20.6111C7.62562 20.6111 7.06696 20.3872 6.60881 19.9393C6.15005 19.4909 5.92067 18.9463 5.92067 18.3056H4.66663V9.59055C4.66663 9.18499 4.80637 8.84644 5.08585 8.57489C5.36472 8.30275 5.71272 8.16669 6.12983 8.16669H18.1089V11.3538H20.1986L23.3333 15.457V18.3056H21.8701C21.8701 18.9463 21.6395 19.4909 21.1783 19.9393C20.7172 20.3872 20.157 20.6111 19.4978 20.6111C18.8393 20.6111 18.2809 20.3872 17.8227 19.9393C17.364 19.4909 17.1346 18.9463 17.1346 18.3056H10.6571C10.6571 18.9498 10.4265 19.4953 9.96529 19.942C9.50352 20.3887 8.94335 20.6111 8.28479 20.6111ZM8.28841 19.7304C8.69586 19.7304 9.04174 19.5922 9.32605 19.316C9.60976 19.0392 9.75161 18.7024 9.75161 18.3056C9.75161 17.9089 9.60976 17.5724 9.32605 17.2961C9.04234 17.0199 8.69646 16.8818 8.28841 16.8818C7.88035 16.8818 7.53478 17.0199 7.25167 17.2961C6.96797 17.5724 6.82611 17.9089 6.82611 18.3056C6.82611 18.7024 6.96797 19.0389 7.25167 19.3151C7.53538 19.5914 7.88096 19.7304 8.28841 19.7304ZM19.5024 19.7295C19.9098 19.7295 20.2554 19.5914 20.5391 19.3151C20.8228 19.0389 20.9646 18.7024 20.9646 18.3056C20.9646 17.9089 20.8228 17.5724 20.5391 17.2961C20.2554 17.0199 19.9098 16.8818 19.5024 16.8818C19.0949 16.8818 18.7493 17.0199 18.4656 17.2961C18.1819 17.5724 18.0401 17.9089 18.0401 18.3056C18.0401 18.7024 18.1819 19.0389 18.4656 19.3151C18.7493 19.5914 19.0949 19.7295 19.5024 19.7295ZM18.1089 15.6607H22.3753L19.7115 12.2355H18.1089V15.6607Z" fill="black"/></svg>';
        }
        jQuery('.cart__goal__message').html(tempStr);
        jQuery('.cc-cart-progress-heading .svg-html').html('');
        jQuery('.cc-cart-progress-heading .svg-html').html(svg);
      }
  });
 }
},1000);
let itemArr = [];
function customMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || "${{amount}}";

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(
    number,
    precision,
    thousands,
    decimal
  ) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }

  var value = "";

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;

    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;

    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;

    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;

    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;

    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
  }

  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString
      .replace(placeholderRegex, value)
      .replace(",00", "");
  } else {
    return formatString
      .replace(placeholderRegex, value)
      .replace(".00", "");
  }
}

//:: END :: Cart progress  :: ==================


$(document).ready(function() {
    // Play the video when mouse enters the element
    $('.grid__item .grid-product__content').on('mouseenter', function() {
        $(this).find('.featured-video').get(0).play(); // Play the video
    });

    // Pause the video when mouse leaves the element
    $('.grid__item .grid-product__content').on('mouseleave', function() {
        $(this).find('.featured-video').get(0).pause(); // Pause the video
        $(this).find('.featured-video').get(0).currentTime = 0; // Reset video to the start (optional)
    });
});

//:: START :: PRODUCT DETAIL PAGE ADD SUB PRODUCT  :: ==================

function toggleWrapperClass($wrapper, total) {
  const $removeBtn = $wrapper.find('.remove-product');

  // “empty” when the total is literally zero
  if (total === 0) {
    $wrapper.addClass('no-product');      // add at 0
    $removeBtn.hide();           // hide trashcan when 0
  } else {
    $wrapper.removeClass('no-product');   // remove above 0
    $removeBtn.show();           // show trashcan when visible
  }
}
$(document).on('click', '.plus-product', function () {
  const $wrapper = $(this).closest('.product-counter-wrapper');
  if(!$wrapper.hasClass('disabled')){
    const $input   = $wrapper.find('.product-input-counter');

    const unit  = Number($input.data('unit'))  || 0;   // 30
    const total = Number($input.val())         || 0;   // current value

    const newTotal = total + unit;
    $input.val(newTotal);
    toggleWrapperClass($wrapper, newTotal);
    orderSummeryTotal();
    variantPrepareData();
  }
});

function orderSummeryTotal(){
  if(jQuery('.main-sub_product_block').find('.product-input-counter').length>0){
    var totalProduct = 0;
    jQuery('.main-sub_product_block').find('.product-input-counter').each(function(){
      totalProduct+=parseInt(jQuery(this).val());
    });
    if(jQuery('.sub_product_totals').find('.sp_total_count').length>0){
      jQuery('.sub_product_totals').find('.sp_total_count').text(totalProduct);
    }
  }
}

$(document).on('click', '.minus-product', function () {
  const $wrapper = $(this).closest('.product-counter-wrapper');
  if(!$wrapper.hasClass('disabled')){
    const $input   = $wrapper.find('.product-input-counter');

    const unit  = Number($input.data('unit'))  || 0;    // 30
    const total = Number($input.val())         || 0;    // current value
    const newTotal = Math.max(0, total - unit);         // 60→30, 30→0

    $input.val(newTotal);
    toggleWrapperClass($wrapper, newTotal);
    orderSummeryTotal();
    variantPrepareData();
  }
});
$(document).on('click', '.remove-product', function () {
  const $wrapper = $(this).closest('.product-counter-wrapper');
  const $input = $wrapper.find('.product-input-counter');
  $input.val(0);
  toggleWrapperClass($wrapper, 0);
  orderSummeryTotal();
  variantPrepareData();
});


jQuery(document).on("click",".page-content--product .payment-buttons,.product-block-buybuttons .payment-buttons",function(e){
  e.preventDefault();
  if(jQuery(this).parent().find('[name="id"]').length>0 && jQuery('.page-content--product').find('.main-sub_product_block').length>0 && jQuery('.page-content--product').find('.main-sub_product_block').is(":visible")){
    var variantHandle = jQuery(this).parent().find('[name="id"]').find('option:selected').attr('data-handle');
    for(var y=0;y<variantHandleData.length;y++){
      //console.log("lellll",jQuery('.page-content--product').find('.sub-product-card').length);
      variantHandle = variantHandleData[y];
      if(jQuery('.page-content--product').find('.main-sub_product_block').length>0 && jQuery('.page-content--product').find('.main-sub_product_block').is(":visible")){
        if(jQuery('.page-content--product .main-sub_product_block').find('.product-counter-wrapper:not(.no-product)').length > 0){
          jQuery('.page-content--product .main-sub_product_block').find('[data-vhandle="'+variantHandle+'"]').find('.product-counter-wrapper:not(.no-product)').each(function(){
            if(jQuery(this).find('.variant-sub-product').find('option').length>0){
              if(jQuery(this).find('.variant-sub-product').find('option[value="'+variantHandle+'"]').length>0){
                var variantId = jQuery(this).find('.variant-sub-product').find('option[value="'+variantHandle+'"]').attr('data-vid');
                var variantQty = jQuery(this).find('.product-input-counter').val();
                itemArr.push({
                  id: variantId,
                  quantity: variantQty
                });
              }
            }
          });
        }
      }
    }
   //console.log("item arr",itemArr);
  }else{
    var variantId = jQuery(this).parent().find('[name="id"]').find('option:selected').val();
    itemArr.push({
      id: variantId,
      quantity: 5
    });
  }
  if(itemArr.length>0){
    var btnobj = jQuery(this).find('.add-to-cart');
    btnobj.addClass('btn--loading');
    addItemsToCart(itemArr,btnobj);
  }
});

function showHideVariantProduct(){
  var $selectedOption = jQuery('.product-single__variants').find('option:selected');
  var mainVariantId   = $selectedOption.val();
  if (
    jQuery('.page-content--product')
      .find('.sub-products-wrapper.variant_wise_' + mainVariantId).length > 0
  ) {
    jQuery('.page-content--product .sub-products-wrapper').hide();
    jQuery('.page-content--product')
      .find('.sub-products-wrapper.variant_wise_' + mainVariantId)
      .show();
  }
}
let variantHandleData = [];
function variantPrepareData(){
  if (jQuery('.product-single__variants').length === 0) {
    return;
  }

  var $selectedOption = jQuery('.product-single__variants').find('option:selected');
  var mainVariantId   = $selectedOption.val();
  var variantSelected   = $selectedOption.attr('data-handle');

  /* Hide all banners */
  jQuery('.sp_tota_banner .img-product-common').hide();
  var totalProduct = 0;
  var totalPrice = 0;
  var finalHtml = '';
  var previousTitle = '';
  jQuery('.main-sub_product_block').find('.product-counter-wrapper:not(.no-product)').each(function () {
    var $wrapper = jQuery(this);
    var qty = parseInt($wrapper.find('.product-input-counter').val()) || 0;
    if (qty === 0) return;
    
    totalProduct += qty;

    var $variantOption = $wrapper
      .find('.variant-sub-product option:selected');
    var variantOptTitle = $wrapper
      .closest('.sub-products-wrapper').attr('data-vtitle');
    if (!$variantOption.length) return;

    var variantPrice = parseFloat($variantOption.attr('data-price')) || 0;
    var productImage = $variantOption.attr('data-pimg');
    var productId    = $variantOption.attr('data-pid');
    var productTitle = $variantOption.attr('data-ptitle');
    var variantId = $variantOption.attr('data-vid');
    var priceTotal = (parseFloat(variantPrice) * qty);
    totalPrice+=priceTotal;
    var priceFinal = customMoney(priceTotal);

    if(variantOptTitle && previousTitle!=variantOptTitle){
      finalHtml+='<div class="subp_dropdown_wrapper"><span class="subp_pouch_label">'+variantOptTitle+'</span>';
    }
    finalHtml+='<div class="subp_dropdown_item"><img class="spd_item_banner" src="' + productImage + '">';
    finalHtml+='<div class="spd_item_content"><h6 class="spd_item_title">' + productTitle + '</h6>';
    finalHtml+='<p class="spd_item_quantity">Quantity: <span class="spd_item_quantity">' + qty + '</span></p>';
    finalHtml+='<p class="spd_item_price">' + priceFinal + '</p></div></div>';
    if(variantOptTitle && previousTitle!=variantOptTitle){
      finalHtml+='</div>';
    }
    previousTitle = variantOptTitle;
    if (productId) {
      jQuery('.sp_tota_banner')
        .find('.img-product-common[data-pid="' + productId + '"]')
        .show();
    }
    if(variantHandleData.indexOf(variantSelected) === -1) {
      variantHandleData.push(variantSelected);
    }
  });
  if (totalProduct === 0) {
    jQuery('.sub_products_dropdown').html('');
    jQuery('.sub_product_totals .sp_total_viewall').hide();
    jQuery('.sub_product_totals_top').find('.sp_total_priceall').hide();
    jQuery('.sub_product_totals_top').find('.sp_total_priceall').text(customMoney(0));
    jQuery('.sub_product_totals').removeClass('dropdown_active');
    return;
  }else{
    if(jQuery('.sub_product_totals_top').find('.sp_total_priceall').length>0){
      jQuery('.sub_product_totals_top').find('.sp_total_priceall').show();
      jQuery('.sub_product_totals_top').find('.sp_total_priceall').text(customMoney(totalPrice));
    }
  }
  jQuery('.sub_product_totals .sp_total_viewall').show();
  jQuery('.sub_products_dropdown').html(finalHtml);
}

function addItemsToCart(itemData, btnobj = '') {
  if (btnobj){
    btnobj.addClass('btn--loading');
    btnobj.find('span').hide();
  }
  $.ajax({
    url: '/cart/add.js',
    method: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify({ items: itemData })
  })
  .done(function () {
    btnobj && btnobj.removeClass('btn--loading');
    btnobj.find('span').show();
    cartDrawerOpen();
    var cart = new theme.CartDrawer
    cart.init()
    cart.open();
    // $("form.ajaxcart .js-qty__num").first().trigger("change");
    // resetCartQuantity();
    // orderSummeryTotal();
    // variantPrepareData();
  })
  .fail(function (xhr, status, errorThrown) {
    btnobj && btnobj.removeClass('btn--loading');

    var resp  = xhr.responseJSON || {};
    var msg   = resp.description || resp.message || 'Something went wrong. Please try again.';
    btnobj.find('span').show();
    console.error('Add‑to‑cart error:', resp);
    alert(msg);
  });
}

const $htmlcustom   = $('html');
const $drawercustom = $('#CartDrawer');

function closeDrawer () {
  $htmlcustom.removeClass('js-drawer-open lock-scroll');
  $drawercustom
    .removeClass('drawer--is-open')
    .removeAttr('tabindex')
    .attr('aria-hidden', true);

  $(document).off('keyup.cartDrawer');
}

$(document).on('click', '.js-drawer-close', e => {
  e.preventDefault();
  closeDrawer();
});

$(document).on('click', e => {
  if($drawercustom.hasClass('drawer--is-open') && !$(e.target).closest('#CartDrawer, .js-open-cart').length) {
    closeDrawer();
  }
});

function resetCartQuantity(){
  if(jQuery('.page-content--product .main-sub_product_block').find('.product-counter-wrapper:not(.no-product)').length > 0){
    jQuery('.page-content--product .main-sub_product_block').find('.product-counter-wrapper:not(.no-product)').each(function(){
      jQuery(this).find('.product-input-counter').val(0);
      jQuery(this).addClass('no-product');
    });
    variantHandleData=[];
  }
}

function cartDrawerOpen(){
  $.getJSON('/cart.js').done(function (cart) {
    var totalCart = cart.item_count;
    if(jQuery('#CartDrawer').length>0){
      jQuery('html').addClass('js-drawer-open').addClass('lock-scroll');
      document.dispatchEvent(new CustomEvent('cart:build', { detail: cart }));
      if(totalCart!=0){
        jQuery('#CartDrawer').find('.cc-cart-progress').show();
      }else{
        jQuery('#CartDrawer').find('.cc-cart-progress').hide();
      }
      jQuery('#CartDrawer').addClass('drawer--is-open');
      jQuery('#CartDrawer').attr('tabindex','-1');
      jQuery('#CartDrawer').find('.cart_drawer__title.drawer__title').find('span').text('('+totalCart+')');
      setTimeout(function(){
        if(jQuery('.header-item--icons').find('.cart-link__bubble.cart-link__bubble--visible').find('span').length>0){
          jQuery('.header-item--icons').find('.cart-link__bubble.cart-link__bubble--visible').find('span').text(totalCart);
        }else{
          jQuery('.header-item--icons').find('.cart-link__bubble.cart-link__bubble--visible').html('<span aria-hidden="true">'+totalCart+'</span>');
        }
      },1000);
    }
    itemArr = [];
  }).fail(function () {
    console.warn('Could not fetch /cart.js');
  });
}

jQuery(document).ready(function(){
  var combineVariant = variantSelected();
  if(combineVariant!=""){
    combineVariant=toHandle(combineVariant);
    console.log("combineVariant",combineVariant);
    disableSubproduct(combineVariant);
  }
});

jQuery(document).on("change",".product-block--variants .variant-input",function(){
  var combineVariant = variantSelected();
  if(combineVariant!=""){
    combineVariant=toHandle(combineVariant);
    disableSubproduct(combineVariant);
    showHideVariantProduct();
  }
});

function disableSubproduct(variantHandle){
  if(jQuery('.page-content--product .main-sub_product_block').find('.product-counter-wrapper').length > 0){
    jQuery('.page-content--product .main-sub_product_block').find('.product-counter-wrapper').each(function(){
      if(jQuery(this).find('.variant-sub-product').find('option').length>0){
        if(jQuery(this).find('.variant-sub-product').find('option[value="'+variantHandle+'"]').length>0){
         jQuery(this).removeClass('disabled');
        }else{
          jQuery(this).addClass('disabled');
        }
      }else{
        jQuery(this).addClass('disabled');
      }
    });
  }
}

function variantSelected(){
  var variantString = '';
  jQuery('.page-content--product').find('.product-block--variants .variant-input').each(function(){
    if(jQuery(this).find('[type="radio"]').is(":checked")){
      if(variantString!=""){
        variantString+='-';
      }
      variantString+=jQuery(this).find('[type="radio"]').val();
    }
  });
  return variantString;
}

function toHandle(str) {
  return str
    .trim()                                   // remove leading/trailing space
    .toLowerCase()                            // Shopify handles are lowercase
    .normalize('NFD')                         // split accents from letters
    .replace(/[\u0300-\u036f]/g, '')          // drop the accents
    .replace(/[^a-z0-9]+/g, '-')              // replace non‑alphanumerics with -
    .replace(/^-+|-+$/g, '');                 // trim hyphens at ends
}
//:: END :: PRODUCT DETAIL PAGE ADD SUB PRODUCT  :: ==================

//:: START :: TOTAL ITEM DROPDOWN  :: ==================
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    const viewAllBtn = e.target.closest(".sp_total_viewall");
    const parentBox = document.querySelector(".sub_product_totals");

    if (viewAllBtn && parentBox) {
      e.preventDefault();
      parentBox.classList.toggle("dropdown_active");
    }
  });
});
//:: END :: TOTAL ITEM DROPDOWN  :: ==================
